import { Anchor, Box, Heading, Paragraph, TextButton } from '@zillow/constellation-10';

type NoConversationsErrorExperienceProps = {
  isNotAuthorized: boolean;
  isComingFromSms: boolean;
  isComingFromEmail: boolean;
  userEmail?: string;
};

export default function NoConversationsErrorExperience({
  isNotAuthorized,
  isComingFromSms,
  isComingFromEmail,
  userEmail,
}: NoConversationsErrorExperienceProps) {
  const handleRefreshClick = (): void => {
    window.location.reload();
  };

  const getUnauthorizedMessage = (): React.ReactNode => {
    if (isComingFromSms || isComingFromEmail) {
      if (userEmail) {
        return (
          <>
            You are currently logged in as <strong>{userEmail}</strong>, but this account cannot access this
            conversation. Ensure you are logged into the correct account and try again.
          </>
        );
      }
      return 'This account does not have access to this conversation. If you have another account, check to make sure you are logged into the right one.';
    }
    return 'You do not have permission to see these messages.';
  };

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', maxWidth: '445px', margin: '0 auto' }}>
      {isNotAuthorized ? (
        <>
          <Paragraph textStyle="body-sm" css={{ marginBottom: 'tighter' }}>
            {getUnauthorizedMessage()}
          </Paragraph>
          {!isComingFromSms && !isComingFromEmail && (
            <Heading level={5} textStyle="body-lg-bold">
              <Anchor href=".">Go to my messages</Anchor>
            </Heading>
          )}
        </>
      ) : (
        <>
          <Paragraph textStyle="body-sm" css={{ marginBottom: 'tighter' }}>
            We&apos;re not quite sure what happened here. Try refreshing the page.
          </Paragraph>
          <Heading level={5} textStyle="body-lg-bold">
            <Anchor asChild>
              <TextButton onClick={handleRefreshClick} tone="brand" textStyle="body-bold">
                Click to refresh
              </TextButton>
            </Anchor>
          </Heading>
        </>
      )}
    </Box>
  );
}
